import { StageLegacy } from '@silvertours/front-features';
import { Runtime } from '@silvertours/front-entities';

const WidgetPage = () => {
  const { brandName } = Runtime.useBrand();
  return <StageLegacy.WidgetStage brandName={brandName} />;
};

export { WidgetPage };
